import { tsValidateArray, tsValidateBoolean, tsValidateOptional, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { ScoreTypes } from './types.js';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_ModifiableProps = {
    variableId: tsValidateUniqueId,
    diseaseProfileId: tsValidateUniqueId,
    expression: tsValidateOptional,
    type: tsValidateValue([...ScoreTypes]),
    defaultScoreCondition: tsValidateBoolean(),
    dialogKey: tsValidateString(undefined, false),
};
const Validator_GeneratedProps = {
    _variableIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_Score = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'scores',
    entityName: 'Score',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'score'
    },
    backend: {
        name: 'scores'
    },
    dependencies: {
        variableId: { dbKey: 'variables', fieldType: 'string' },
        _variableIds: { dbKey: 'variables', fieldType: 'string[]' }
    }
};
//# sourceMappingURL=db-def.js.map